import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import * as yup from 'yup';
import { PHONE_FORMAT_REGEX } from "../../../../constants/consts";
export var COUNTRY_OF_INTEREST_DATA = [{
  value: 'AU',
  label: 'Australia'
}, {
  value: 'CA',
  label: 'Canada'
}, {
  value: 'GB',
  label: 'United Kingdom'
}, {
  value: 'US',
  label: 'USA'
}];
export var COUNTRY_OF_INTEREST_DICT = {
  Australia: 'AU',
  Canada: 'CA',
  'United Kingdom': 'GB',
  USA: 'US'
};
export var SERVICE_OF_INTEREST_DATA = [{
  value: 1,
  label: 'Programs'
}, {
  value: 2,
  label: 'Scholarships'
}, {
  value: 3,
  label: 'Visa Services'
}, {
  value: 4,
  label: 'Insurance'
}, {
  value: 5,
  label: 'Accommodation'
}, {
  value: 6,
  label: 'Bank Accounts'
}, {
  value: 7,
  label: 'Tourism'
}, {
  value: 8,
  label: 'Other'
}];
export var SERVICE_OF_INTEREST_DICT = {
  Programs: 1,
  Scholarships: 2,
  'Visa Services': 3,
  Insurance: 4,
  Accommodation: 5,
  'Bank Accounts': 6,
  Tourism: 7,
  Other: 8
};
export var defaultErrorMessage = {
  requiredFields: 'This is required.',
  uniqueCountryEntry: 'Please make sure each country entry is unique.'
};
var DEFAULT_MAX_INPUT_LENGTH = 120;
export var DEFAULT_VALUES = {
  birthDate: '',
  citizenship: '',
  countryOfInterest: [],
  servicesOfInterest: [],
  didDeclaration: false,
  email: '',
  givenName: '',
  middleName: '',
  familyName: '',
  gender: '',
  phone: '',
  referralSource: '',
  passportNumber: '',
  passportExpiry: ''
};
export var FORM_VALIDATION = yup.object({
  givenName: yup.string().trim().required(defaultErrorMessage.requiredFields).max(100).label('Given name'),
  middleName: yup.string().trim().max(100).label('Middle name'),
  familyName: yup.string().trim().max(100).required(defaultErrorMessage.requiredFields).label('Family name'),
  email: yup.string().trim().required(defaultErrorMessage.requiredFields).max(DEFAULT_MAX_INPUT_LENGTH).email('Please enter a valid email'),
  phone: yup.string().trim().required(defaultErrorMessage.requiredFields).matches(PHONE_FORMAT_REGEX, 'Phone number format is invalid').max(DEFAULT_MAX_INPUT_LENGTH).min(6, 'Phone number must be atleast 6 characters').label('Phone number'),
  citizenship: yup.string().trim().required(defaultErrorMessage.requiredFields).label('This'),
  gender: yup.string().trim().required(defaultErrorMessage.requiredFields).label('This'),
  birthDate: yup.string().trim().required(defaultErrorMessage.requiredFields).label('Birth date'),
  referralSource: yup.string().trim().required(defaultErrorMessage.requiredFields).label('Referral Source'),
  servicesOfInterest: yup.array().of(yup.string()).required(defaultErrorMessage.requiredFields).test({
    message: 'Selection is required.',
    test: function test(arr) {
      return arr.length !== 0;
    }
  }).label('Services Of Interest'),
  countryOfInterest: yup.array().of(yup.string()).required(defaultErrorMessage.requiredFields).test({
    message: 'Selection is required.',
    test: function test(arr) {
      return arr.length !== 0;
    }
  }).label('Country of Interest'),
  didDeclaration: yup.bool().oneOf([true], 'Selection is required.'),
  passportNumber: yup.string().trim().label('Passport number').max(50),
  passportExpiry: yup.string().trim().label('Passport expiry date')
});